import { render, staticRenderFns } from "./RequestForkliftTruckField.vue?vue&type=template&id=2921df1e&"
import script from "./RequestForkliftTruckField.vue?vue&type=script&lang=js&"
export * from "./RequestForkliftTruckField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QIcon,QToggle} from 'quasar'
component.options.components = Object.assign({QIcon,QToggle}, component.options.components || {})
